import React from 'react'

import { SvgCheckCircle } from '@chilipiper/icons/src/design-system/CheckCircle'

import { Alert, CustomAlertProps } from './Alert'

export const SuccessAlert = (props: CustomAlertProps) => {
  return <Alert icon={SvgCheckCircle} iconColor='fg/success' {...props} />
}
